export const DefaultWasteAmountUnit = "l";
